import { render, staticRenderFns } from "./crafts.vue?vue&type=template&id=fcdf52ac&"
import script from "./crafts.vue?vue&type=script&lang=js&"
export * from "./crafts.vue?vue&type=script&lang=js&"
import style0 from "./crafts.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports